import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Module } from 'src/app/kuba/follow-ups/models/deviation';
import { BaseServices } from '../kuba.services';
import { followUpTabs } from './followups-tabs';
import { Subscription } from 'rxjs';
import { FeaturesBaseServices } from '../features/services/features-base.services';
import { BusinessServices } from '../businesses/services/business.services';

@Component({
    templateUrl: 'followups.component.html',
  standalone: false
})
export class FollowUpsComponent implements OnInit {
    pageTitle: string;
    additionalFeatures: any;
    enabledAdditionalFeatures: any;
    fId: number;
    initialPage: any;
    vehicleTitle: string;
    firstRoute = true;
    routeSub:Subscription;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private businessServices: BusinessServices
    ) {
        this.fId = Module.FOLLOWUPS;
        const workingModule = this.readWorkingModule();
        if (workingModule?.name === 'Follow up' || workingModule?.name === 'Followup') {
            this.enabledAdditionalFeatures = followUpTabs(workingModule.children, BaseServices.roleId, window.name === 'Remote');

            if (this.enabledAdditionalFeatures.length > 0) {
                // A deep link, such as a tab picked in the hover sub-navigation, keeps its tab.
                this.openFirstTabAtModuleRoot();
                this.firstRoute  = true;
                this.routeSub = this.router.events.subscribe(val=>{
                    if(val instanceof NavigationEnd){
                        if(this.router.url.indexOf('follow-up') > -1){
                            if(this.firstRoute){
                                this.firstRoute = false;
                            }
                            else{
                                this.openFirstTabAtModuleRoot();
                            }
                        }
                    }
                });
            }
        } else if (BaseServices.BusinessId > 0) {
            this.businessServices.getById(BaseServices.BusinessId).subscribe(result => {
                let featureBase = BaseServices.getUserFeatures();
                let template = <any>JSON.parse(featureBase.FeaturesTemplate);
                featureBase.FeaturesTemplate = JSON.stringify(template.filter((x:any) =>
                    (x.navigationRoles.indexOf('B') > -1 && x.IsFeature.indexOf('N') > -1)
                    || (x.navigationRoles.indexOf('B') > -1 && x.IsDefault === 1)));
                featureBase.Features = result.Features;
                featureBase.Type = 'business';
                featureBase.Details = result;
                let baseFeatures = FeaturesBaseServices.getFeatureDetails(featureBase).filter((x:any) => x.id == 15);
                this.setupFollowUpNavigation(baseFeatures);
                // need to do something to add feature id on URL
            });
        } else {
            const leftNavStr = sessionStorage.getItem('leftNav');
            if (leftNavStr) {
                const baseFeatures = JSON.parse(leftNavStr).filter((x: any) => x.id === 15);
                this.setupFollowUpNavigation(baseFeatures);
            }
        }
    }

    private setupFollowUpNavigation(baseFeatures: any[]) {
        if (!(baseFeatures && baseFeatures.length)) return;
        sessionStorage.setItem('workingModule', JSON.stringify(baseFeatures[0]));
        this.enabledAdditionalFeatures = followUpTabs(baseFeatures[0].children, BaseServices.roleId, window.name === 'Remote');
        if (this.enabledAdditionalFeatures.length > 0) {
            this.openFirstTabAtModuleRoot();
            this.firstRoute = false;
            this.routeSub = this.router.events.subscribe(val => {
                if (val instanceof NavigationEnd) {
                    if (this.router.url.indexOf('follow-up') > -1) {
                        if (this.firstRoute) {
                            this.firstRoute = false;
                        } else {
                            this.openFirstTabAtModuleRoot();
                        }
                    }
                }
            });
        }
    }

    /**
     * Opens the first tab when the URL points at the Follow-up root, so a deep
     * link to another tab is not overridden.
     */
    private openFirstTabAtModuleRoot() {
        const segments = this.router.url.split(/[?#]/)[0].split('/').filter(Boolean);
        const lastSegment = (segments[segments.length - 1] ?? '').split(';')[0];
        if (lastSegment === 'follow-up') {
            this.router.navigate([this.enabledAdditionalFeatures[0].linkText, { Id: this.fId }],
                { relativeTo: this.route });
        }
    }

    /** The module stored by the navigation, or null when it is missing or unreadable. */
    private readWorkingModule(): any {
        try {
            return JSON.parse(sessionStorage.getItem('workingModule') ?? 'null');
        } catch {
            return null;
        }
    }

    ngOnInit() {
        document.querySelector("body").classList.remove("opened");
    }
    ngOnDestroy(){
        this.firstRoute=true;
        if(this.routeSub){
            this.routeSub.unsubscribe();
        }
    }
}
